<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    <path d="M19.4,10.913a.251.251,0,0,0-.321.041,5.222,5.222,0,0,1-3.449,1.734,4.938,4.938,0,0,1-3.476-1.083.25.25,0,0,0-.311,0,4.859,4.859,0,0,1-3.071,1.1c-.131,0-.264-.006-.4-.017a5.231,5.231,0,0,1-3.464-1.738.25.25,0,0,0-.319-.043,3.911,3.911,0,0,1-2.331.645A.251.251,0,0,0,2,11.8v9.572a1.5,1.5,0,0,0,1.5,1.5h17a1.5,1.5,0,0,0,1.5-1.5v-9.56a.251.251,0,0,0-.265-.25A3.841,3.841,0,0,1,19.4,10.913ZM15,15.236a.382.382,0,0,1,.4-.361h3.2a.382.382,0,0,1,.4.361v5.285a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5Zm-9.5-.028a.356.356,0,0,1,.375-.333h5.246a.356.356,0,0,1,.375.333v3.334a.356.356,0,0,1-.375.333H5.873a.356.356,0,0,1-.375-.333Z"/><path d="M21.789,1.125H18.636a.252.252,0,0,0-.2.1.248.248,0,0,0-.034.225L19.96,6.138A.768.768,0,0,1,20,6.375c0,2.151,0,2.787,0,2.991a.251.251,0,0,0,.105.208,2.287,2.287,0,0,0,2.271.322A2.717,2.717,0,0,0,24,7.44V6.494a.274.274,0,0,0-.016-.089L22.1,1.462C22.016,1.243,21.877,1.125,21.789,1.125Z"/><path d="M18.452,9.313a.247.247,0,0,0,.046-.144V6.537a.234.234,0,0,0-.013-.079L16.764,1.3a.25.25,0,0,0-.237-.171H13a.251.251,0,0,0-.177.073.255.255,0,0,0-.073.177l0,8.646a3.059,3.059,0,0,0,2.764,1.172A3.963,3.963,0,0,0,18.452,9.313Z"/><path d="M11.25,10.021l0-8.646a.25.25,0,0,0-.25-.25H7.469a.25.25,0,0,0-.237.171L5.511,6.458a.234.234,0,0,0-.013.079V9.163a.253.253,0,0,0,.045.144A3.954,3.954,0,0,0,8.5,11.194,3.029,3.029,0,0,0,11.25,10.021Z"/><path d="M4,9.375v-3a.768.768,0,0,1,.038-.237L5.6,1.454a.248.248,0,0,0-.034-.225.25.25,0,0,0-.2-.1H2.211c-.088,0-.227.118-.31.337L.018,6.405A.274.274,0,0,0,0,6.494V7.44A2.709,2.709,0,0,0,1.623,9.889,1.989,1.989,0,0,0,4,9.375Z"/>
  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'shop',
    },
    name: {
      type: String,
      required: false,
      default: 'Shop',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>